
<div class="container mt-5">


  <!--Section: Content-->
  <section class="dark-grey-text">

    <!-- Section heading -->
    <h2 class="text-center font-weight-bold text-sucess mb-4 pb-2">
      Culture Tradition and Arts 
    </h2>
    <!-- Section description -->
    <p class="text-center mx-auto w-responsive mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, error amet numquam iure provident voluptate esse quasi, veritatis totam voluptas nostrum quisquam eum porro a pariatur veniam.</p>

  	<!-- Grid row -->
    <!-- item-1 -->
      <div class="row align-items-center">
      <!-- Grid column -->
      <div class="col-lg-5 col-xl-4">

        <!-- Featured image -->
        <div class="view overlay rounded z-depth-1-half mb-lg-0 mb-4">
          <img class="img-fluid" src="https://1.bp.blogspot.com/-2oflfjnMvvo/XRWZyCQND0I/AAAAAAAAAIk/ptGQJfrcFzAVWLJ8ETb2PTesyGUFOdNmACLcBGAs/s1600/PicsArt_06-28-09.39.42.jpg" alt="Sample image">
          <a>
            <div class="mask rgba-white-slight"></div>
          </a>
        </div>

      </div>
      <!-- Grid column -->

      <!-- Grid column -->
      <div class="col-lg-7 col-xl-8">

        <!-- Post title -->
        <h4 class="font-weight-bold mb-3"><strong>Jhumar Folk Dance:</strong></h4>
        <!-- Excerpt -->
        <p class="dark-grey-text">Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit
          quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus
          et aut officiis cum soluta nobis est eligendi placeat facere aut rerum.</p>
        <!-- Post data -->
        <p>by <a class="font-weight-bold">Jessica Clark</a>, 19/04/2018</p>
        <!-- Read more button -->
        <a class="btn btn-primary btn-md mx-0 btn-rounded">Read more</a>

      </div>
      <!-- Grid column -->

    </div>
    <!-- Grid row -->


    <hr class="my-5">
<!-- end item -->

<!-- item-2 -->

    <div class="row align-items-center">
      <!-- Grid column -->
      
      <!-- Grid column -->

      <!-- Grid column -->
      <div class="col-lg-7 col-xl-8">

        <!-- Post title -->
        <h4 class="font-weight-bold mb-3"><strong>Mayurbhanj Chhau dance</strong></h4>
        <!-- Excerpt -->
        <p class="dark-grey-text">Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit
          quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus
          et aut officiis cum soluta nobis est eligendi placeat facere aut rerum.</p>
        <!-- Post data -->
        <p>by <a class="font-weight-bold">Jessica Clark</a>, 19/04/2018</p>
        <!-- Read more button -->
        <a class="btn btn-primary btn-md mx-0 btn-rounded">Read more</a>

      </div>
      <!-- Grid column -->
      <div class="col-lg-5 col-xl-4">

          <!-- Featured image -->
          <div class="view overlay rounded z-depth-1-half mb-lg-0 mb-4">
            <img class="img-fluid" src="https://1.bp.blogspot.com/-BXKHODm-w2k/XRWXQK6GfuI/AAAAAAAAAIQ/u137Z6wY9OIf2ElPv5IkIGg3Kb99D0OvQCLcBGAs/s1600/PicsArt_06-28-09.56.44.jpg" alt="Sample image">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
  
        </div>
    </div>
    <!-- Grid row -->
    <hr class="my-5">

<!-- end item-2 -->







    
  </section>
  <!--Section: Content-->


</div>